import React from 'react';
import { AcceptedProps } from './interface/accepted-props';
import RangeType from './type/range/range';

const Range: React.FC<AcceptedProps> = (props) => {
  return <RangeType {...props} />
}

export default Range;